import { useId } from 'react'
import { STAY_STOPS, stopIndex, stayText } from '../lib/stays.js'
import { humanizeMinutes, pragueClock } from '../lib/i18n.js'

/**
 * Any stay the chips don't cover, by dragging: from no stay (the free/paid map)
 * at the far left up to a whole day. It shares one scale with the chips, so a
 * chip moves the thumb and the thumb lights up a chip.
 */
export default function StaySlider({ t, durationMin, startDate, onChange }) {
  const id = useId()
  const index = durationMin ? stopIndex(durationMin) : 0
  const end = durationMin ? pragueClock(new Date(startDate.getTime() + durationMin * 60000)) : null
  const value = durationMin ? t('durationHint', humanizeMinutes(durationMin, t), end) : t('stayNone')

  return (
    <div className="slider-field">
      <div className="slider-field__head">
        <label className="section__title" htmlFor={id}>
          {t('durationTitle')}
        </label>
        <output className={`pill ${durationMin ? 'is-accent' : ''}`} htmlFor={id}>
          {value}
        </output>
      </div>
      <input
        id={id}
        className="slider"
        style={{ '--pct': `${(index / (STAY_STOPS.length - 1)) * 100}%` }}
        type="range"
        min="0"
        max={STAY_STOPS.length - 1}
        step="1"
        value={index}
        onChange={(e) => onChange(stayText(STAY_STOPS[Number(e.target.value)]))}
        aria-valuetext={value}
      />
    </div>
  )
}
